import isEmpty from 'lodash/isEmpty';

export const getErrorFields = (error) => {
  const fields = {};
  if (isEmpty(error.registrationOption)) {
    fields.registrationOption = '';
  } else {
    if (error.registrationOption.value === 'tin' && isEmpty(error.tin)) {
      fields.tin = '';
    }
    if (
      error.registrationOption.value === 'requestId' &&
      isEmpty(error.requestId)
    ) {
      fields.requestId = '';
    }
    if (
      error.registrationOption.value === 'trackingNumber' &&
      isEmpty(error.trackingNumber)
    ) {
      fields.trackingNumber = '';
    }
  }
  return fields;
};
